import React from "react";
import MaterialSelect from "@mui/material/Select";
import MaterialPagination from "@mui/material/Pagination";
import MenuItem from "@mui/material/MenuItem";
import { pageOptions } from "StaticData/UserManageMent/status";
import { Box, styled } from "@mui/material";

const StyledPagination = styled(MaterialPagination)(({ theme }) => ({
  "& ul": {
    display: "inline-flex",
    padding: 0,
    margin: 0,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 6,
  },
  "& li": {
    listStyle: "none",
    borderRight: `1px solid ${theme.palette.divider}`,
    "&:last-of-type": {
      borderRight: "none",
    },
  },
  "& .MuiPaginationItem-root": {
    margin: 0,
    borderRadius: 0,
    border: "none",
    width: "40px",
    height: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&.Mui-selected": {
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      ":hover": {
        backgroundColor: theme.palette.primary.main,
      },
    },
    "& .MuiPaginationItem-previousNext.Mui-disabled": {
      opacity: 0.5,
    },
  },
}));

const StyledSelect = styled(MaterialSelect)(({ theme }) => ({
  "& .MuiSelect-select": {
    padding: "0px 32px 0px 10px !important",
    height: "28px",
    borderRadius: "4px",
    border: `1px solid ${theme.palette.divider} !important`,
    backgroundColor: theme.palette.common.white + " !important",
  },
}));

export interface PaginationProps {
  page: number;
  onPageChange: (v: number) => void;
  perPage: number;
  onPerPageChange: (v: { value: number }) => void;
  pageTotalCount: number;
}

const Pagination: React.FC<PaginationProps> = ({
  page,
  onPageChange,
  perPage,
  onPerPageChange,
  pageTotalCount,
}) => {
  const safePage = pageTotalCount > 0 ? Math.min(page, pageTotalCount) : 1;
  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, m: 6 }}>
      <StyledSelect
        variant="outlined"
        value={perPage}
        size="small"
        onChange={(e) => onPerPageChange({ value: Number(e.target.value) })}
      >
        {pageOptions.map((item) => (
          <MenuItem value={item.value} key={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </StyledSelect>
      <StyledPagination
        count={pageTotalCount}
        page={safePage}
        onChange={(_, newPage) => onPageChange(newPage)}
        variant="outlined"
        shape="rounded"
      />
    </Box>
  );
};

export default Pagination;
